import React from "react";
import TextView from "../../../TextView";
import ColorPaletteModal from "../../../SegmentBuilder/Shared/ColorPalette/ColorPaletteModal";
import { Container } from "../../CreateWheelPopup.styled";

const WheelColorPalette = ({setSelectedWheelPalette }) => {
  return (
    <Container>
      <TextView variant="title" style={{ textAlign: "center" }}>
        Generate a color palette for your wheel!
      </TextView>

      <ColorPaletteModal 
        paletteType="wheel" 
        isWheelWizard={true}
        onPaletteChange={setSelectedWheelPalette}
      />
    </Container>
  );
};

export default WheelColorPalette;
